import { corridorFrame, type CorridorFrameVariants } from './CorridorFrame.css';

type CorridorFrameProps = {
    tone: CorridorFrameVariants['tone'];
    left: number;
    right: number;
};

export const CorridorFrame = ({ tone, right, left }: CorridorFrameProps) => {
    return (
        <div
            className={corridorFrame({ tone })}
            style={{
                left: `${left}%`,
                width: `${Math.max(right - left, 0)}%`,
            }}
        />
    );
};
